import React from "react";
import { Input, Popover } from 'antd'
import { StickyTable, Row, Cell } from 'react-sticky-table';
import { useDispatch, useSelector } from "react-redux";
import { changeIndicadorValue, resetIndicador, changeFilter, get_ventas_apv } from '../actions/evaluacionOptima'
import moment from 'moment';
import NumberFormat from 'react-number-format';


const estilos = {
    Encabezado: {
        textAlign: 'center',
        backgroundColor: 'rgb(217,217,217)',
        width: '200px',
        borderBottom: '1px solid black',
        borderTop: '1px solid black',
        fontWeight: 'bold',

    },
    Titulo: {
        backgroundColor: 'rgb(47, 117, 181)',
        textAlign: 'center',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        paddingTop: '0rem',
        paddingBottom: '0rem',
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
        maxWidth: '500px'

    },
    Subtitulo: {
        color: 'black',
        textTransform: 'none',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingTop: '0rem',
        paddingBottom: '0rem',
        borderBottom: '1px solid black',
        borderTop: '1px solid black',
        maxWidth: '500px',
        backgroundColor: 'white'
    },
    Indicador: {

        color: 'black',
        textTransform: 'none',
        fontWeight: 'normal',
        textAlign: 'left',
        paddingTop: '0rem',
        paddingBottom: '.5rem',
        maxWidth: '500px'

    },
    CeldaSubtitulo: {
        textAlign: 'center',
        borderBottom: '1px solid black',
        borderTop: '1px solid black',
        paddingTop: '0.2rem',
        paddingBottom: '0.2rem',
        backgroundColor: 'white',
    },
    CeldaIndicador: {
        textAlign: 'center',
        paddingTop: '0.5rem',
        paddingBottom: '0rem',
        backgroundColor: 'transparent'

    },
    CeldaTitulo: {
        backgroundColor: 'rgb(47, 117, 181)',
        borderBottom: '1px solid black',
        borderTop: '1px solid black',
        paddingTop: '0.2rem',
        paddingBottom: '0.2rem',
        color: 'white',
        textAlign: 'center',
    },

    Input: {
        textAlign: 'center'
    },

}

function TabContent(props) {


    const dispatch = useDispatch();

    const puesto = useSelector(state => state.evaluacionOptima.puesto)
    const indicadores = useSelector(state => state.evaluacionOptima.indicadores)
    const calificaciones = useSelector(state => state.evaluacionOptima.calificaciones)
    console.log(calificaciones)
    const fechaValida = useSelector(state => state.evaluacionOptima.fechaValida);
    const ventasAPV = useSelector(state => state.evaluacionOptima.ventasAPV);
    const columnas = useSelector(state => state.evaluacionOptima.columnas)
    const apvCumplen = useSelector(state => state.evaluacionOptima.apvCumplen)
    const marca = useSelector(state => state.evaluacionOptima.marca)
    const unidadNegocio = useSelector(state => state.evaluacionOptima.unidadNegocio)
    const fecha = useSelector(state => state.evaluacionOptima.fecha)
    let anio = fecha == null ? moment().format("YYYY") : fecha.format("YYYY")
    let mes = fecha == null ? moment().format("MM") : fecha.format("MM")

    const onChange = (col, ind, e, tipo) => {
        if (e.key === 'Enter' || e.key == 'Tab') {
            const val = e.target.value.replace('%', '').replace('$', '').replaceAll(',', '');
            dispatch(resetIndicador())
            switch (col) {
                case 1:
                    cambiaValorObjetivo(ind, col, val, tipo);
                    break;
                case 2:
                    cambiaValorReal(ind, col, val, tipo);
                    break;
                case 3:
                    cambiaCumplimiento(ind, col, val)
                    break;
                default:
                    break;
            }
        }
    }

    function cambiaValorObjetivo(ind, col, val, tipo) {
        console.log('Cambia objetivo', tipo, indicadores[ind].key, indicadores[ind].Indicador, val)
        /**Obtiene los ID relacionados con el indicador que se modifica 
         * Base: Indicador que toma en cuenta para realizar operaciones
         * Padre: Indicador que totaliza o toma los valores del indicador modificado
         * Afecta: Indicador que se afectará al modificar el valor del indicador (no necesariamente del mismo padre o grupo de indicadores)
         */
        let IdAfecta = indicadores[ind].IdAfecta;
        let IdBase = indicadores[ind].IdBase;
        let IdPadre = indicadores[ind].IdPadre;
        let IdInd = indicadores[ind].key;
        /**Se modifica el valor del indicador */
        indicadores[ind].Respuestas[1].Valor = val;
        indicadores[ind].Modificado = true;
        dispatch(changeFilter('CambiosGuardados', false));
        //Variable para guardar valor para afectar en demas indicadores
        let valor = 0;
        let valorBase = 0;

        //Variables para recalcular el cumplimiento
        let indicadorReal = 0;
        let valorReal = 0;
        let tipoCambioReal = 0;

        /**Se obtiene posicion de indicadores relacionados en array de indicadores */
        let indicadorBase = indicadores.findIndex(obj => obj.key == IdBase)
        let indicadorAfecta = IdAfecta == 0 ? 0 : indicadores.findIndex(obj => obj.key == IdAfecta);
        let indicadorPadre = indicadores.findIndex(obj => obj.key == IdPadre)

        /**Depende del tipo de cambio se calcula el valor para el indicador al que afectara.
         * Este valor se almacena en tabla eo_datosmanuales, campo TipoCambio
         */

        let columnaAfecta = 1;
        switch (tipo) {
            case 1:
                //Tipo 1: afecta valores en su indicador padre. Divide el valor capturado entre el valor que se tenga en el indicador base
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;

                valor = Math.round((val / valorBase) * 100);
                //tipoI = indicadores[indicadorPadre].Respuestas[2].TipoCambio == null ? 1 : indicadores[indicadorPadre].Respuestas[2].TipoCambio;
                valorReal = valor;
                //tipoValor = '';

                indicadorReal = indicadorPadre;
                valorReal = val;
                tipoCambioReal = indicadores[indicadorPadre].Respuestas[2].TipoCambio;
                cambiaValorReal(indicadorPadre, 2, val, indicadores[indicadorPadre].Respuestas[2].TipoCambio)
                break;
            case 2:
                //Tipo 2: Al modificar el objetivo solo se actualizará el cumplimiento tomando en cuenta el valor real. Solo se afecta a si mismo sin tomar en cuenta valores extras
                indicadorReal = ind;
                valorReal = Math.round(indicadores[ind].Respuestas[2].Valor * 100) / 100;
                tipoCambioReal = indicadores[ind].Respuestas[2].TipoCambio
                cambiaValorReal(ind, 2, valorReal, tipoCambioReal);
                break;
            case 3:

                //Tipo 3: Se toma un valor base que conforma un porcentaje y se calcula junto al valor capturado
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;

                valor = (val * (1 + (valorBase / 100)).toFixed(2)).toFixed(1);

                indicadorReal = indicadorAfecta;
                valorReal = indicadores[indicadorAfecta].Respuestas[2].Valor;
                tipoCambioReal = indicadores[indicadorAfecta].Respuestas[2].TipoCambio;

                cambiaValorReal(indicadorReal, 2, valorReal, 3);

                break;
            case 4:
                //Tipo 4: Al modificarse modifica el objetivo de otros indicadores haciendo una resta entre la base y el valor. Modifica en cadena a varios indicadores 
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;
                valor = (valorBase - val).toFixed();
                //tipoValor = '';
                break;
            case 5:
                /**Tipo 5: Repite el valor para almacenarlo en el indicador que afecte */
                valor = val;
                break;
            case 6:
                /**Tipo 6: Toma el  valor base del indicador a afectar para realizar los calculos*/
                IdBase = indicadores[indicadorAfecta].IdBase;
                indicadorBase = indicadores.findIndex(o => o.key == IdBase);
                //
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;
                //
                valor = (valorBase / val).toFixed();
                dispatch(get_ventas_apv(valor, indicadores, ind));
                break;
            case 7:
                //Tipo 7: Toma el valor base del indicador que afecta para hacer los calculos, se multiplican los valores
                IdBase = indicadores[indicadorAfecta].IdBase;
                indicadorBase = indicadores.findIndex(o => o.key == IdBase);

                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;
                valor = (valorBase * val).toFixed();
                break;
            case 8:
                valor = indicadores[indicadorAfecta].Respuestas[1].Valor;
                cambiaValorReal(indicadorAfecta, 2, val, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 9:
                valor = indicadores[indicadorAfecta].Respuestas[1].Valor;
                indicadorBase = indicadores.findIndex(o => o.key == indicadores[indicadorAfecta].IdBase)
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;

                valorReal = ((val / valorBase) * 100).toFixed(2);

                cambiaValorReal(indicadorAfecta, 2, valorReal, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 10:
                valor = indicadores[indicadorAfecta].Respuestas[1].Valor;
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;

                valorReal = ((valorBase / val) * 100).toFixed(2);

                cambiaValorReal(indicadorAfecta, 2, valorReal, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                break;
            case 11:
                valor = indicadores[indicadorAfecta].Respuestas[1].Valor;
                cambiaValorReal(indicadorAfecta, 2, val, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                break;
            case 12:
                IdBase = indicadores[indicadorAfecta].IdBase
                indicadorBase = indicadores.findIndex(o => o.key == IdBase);
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;
                valor = (val * (valorBase / 100)).toFixed();
                break;
            case 13:
                valor = indicadores[indicadorAfecta].Respuestas[1].Valor;
                break;
            case 14:
                indicadorBase = indicadores.findIndex(o => o.key == indicadores[indicadorAfecta].IdBase);
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;

                valor = (val * (valorBase / 100)).toFixed(2);

                valorReal = indicadores[ind].Respuestas[2].Valor;
                tipoCambioReal = indicadores[ind].Respuestas[2].TipoCambio

                cambiaValorReal(ind, 2, valorReal, tipoCambioReal);
                break;
            case 15:

                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                let cum = (Math.round(valorBase) / Math.round(val)) * 100;
                valor = cum > 100 ? 100 : cum;

                indicadores[indicadorAfecta].Respuestas[2].TipoValor = '%';
                columnaAfecta = 2;
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                break;
            case 16:
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;
                valor = Math.round((valorBase / 100) * val);
                break;
            case 17:
                cambiaValorReal(indicadorAfecta, 2, val, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                columnaAfecta = 2;
                break;
            default:
                break;
        }

        if (indicadorAfecta !== 0 && columnaAfecta == 1) {

            cambiaValorObjetivo(indicadorAfecta, 1, valor, indicadores[indicadorAfecta].Respuestas[1].TipoCambio);
        }

        /**Se toman los indicadores que se van a replicar para cambiar el valor */
        let replicas = indicadores.filter(ob => ob.IdReplica == IdInd)
        if (replicas.length > 0) {
            replicas.forEach((r) => {
                let index = indicadores.findIndex(o => o.key == r.key);
                cambiaValorObjetivo(index, 1, val, indicadores[index].Respuestas[1].TipoCambio);
            })
        }

        dispatch(changeIndicadorValue(col, val, indicadores))
    }

    function cambiaValorReal(ind, col, val, TipoCambio) {
        console.log('Cambia real', TipoCambio, indicadores[ind].key, indicadores[ind].Indicador, val)
        /**Cambia la el dato en el indicador actual */
        indicadores[ind].Respuestas[2].Valor = val;
        indicadores[ind].Respuestas[2].TipoValor = indicadores[ind].Respuestas[2].TipoValor;
        indicadores[ind].Modificado = true;
        dispatch(changeFilter('CambiosGuardados', false));
        /**Variables para calculos */
        let cumplimiento = 0;
        let valorBase = 0;
        let valor = 0;
        let replicas = [];
        /**ID de indicadores para hacer calculos y afectar en cadena */
        let idBase = indicadores[ind].IdBase;
        let idAfecta = indicadores[ind].IdAfecta;
        let idPadre = indicadores[ind].IdPadre;
        /**Toma index de los indicadores relacionados */
        let indicadorBase = indicadores.findIndex(o => o.key == idBase);
        let indicadorAfecta = indicadores.findIndex(o => o.key == idAfecta);
        let indicadorPadre = indicadores.findIndex(o => o.key == idPadre);
        /**
         * Segun el tipo de cambio que tiene, calcula el valor para indicadores a los que afecte
        */
        switch (TipoCambio) {
            case 1:
                //Tipo 1: el valor capturado lo divide entre el valor base y calcula cumplimiento
                /**Toma el valor que necesita para hacer calculo de cumplimiento */
                valorBase = indicadores[ind].Respuestas[1].Valor;
                //Cambia el cumplimiento del indicador
                valor = ((val / valorBase) * 100).toFixed(2)
                valor = valor >= 100 ? 100 : valor;
                cambiaCumplimiento(ind, 3, valor);
                //indicadores[ind].Respuestas[3].Valor = valor;
                //indicadores[ind].Respuestas[3].TipoValor = '%';
                if (indicadores[ind].CapturaCalificacion) {
                    calificacionIndicador(ind);
                }
                //Los el cumplimiento de este indicador se promedia para sacar promedio de indicador padre
                if (indicadores[indicadorPadre].TipoIndicador == 'Indicador') {
                    calculaPromedioCumplimiento(ind);
                }
                break;
            case 2:
            case 4:
                /** afecta =  base - valor */
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                valor = valorBase - val;
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                cumplimiento = valor > 0 ? 0 : 100;
                indicadores[indicadorPadre].Respuestas[3].TipoValor = '%';
                indicadores[indicadorPadre].Modificado = true;
                if (TipoCambio == 2) {
                    indicadores[indicadorPadre].Respuestas[3].Valor = cumplimiento;
                    calculaPromedioCumplimiento(indicadorPadre);
                } else {
                    cambiaCumplimiento(indicadorAfecta, 3, cumplimiento)
                    calificacionIndicador(indicadorPadre)
                }
                break;
            case 3:
                valorBase = indicadores[ind].Respuestas[1].Valor;
                valor = ((val / valorBase) * 100).toFixed(1)
                valor = valor >= 100 ? 100 : valor;
                cambiaCumplimiento(ind, 3, valor);
                if (indicadores[ind].CapturaCalificacion) {
                    calificacionIndicador(ind);
                }
                let id = indicadores[ind].key;
                let replicasOB = indicadores.filter(ob => ob.IdReplica == id && ob.puesto == indicadores[ind].puesto)
                replicasOB.forEach((r) => {
                    let index = indicadores.findIndex(o => o.key == r.key);
                    cambiaValorObjetivo(index, 1, val, indicadores[index].Respuestas[1].TipoCambio);
                })
                break;
            case 5:
            case 6:
            case 7:
            case 8:
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                if (TipoCambio == 5 || TipoCambio == 7) {
                    valor = (val / valorBase).toFixed(2); //5
                    indicadores[ind].Respuestas[2].TipoValor = '$';
                } else if (TipoCambio == 6 || TipoCambio == 8) {
                    valor = (valorBase / val).toFixed(2); //6
                }

                if (TipoCambio == 7 || TipoCambio == 8) {
                    valor = (valor * 100).toFixed(2);
                }
                valor = isFinite(valor) ? valor : 0;
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 9:
                valorBase = indicadores[ind].Respuestas[1].Valor;
                valor = parseFloat(val) > parseFloat(valorBase) ? 0 : 100;
                indicadores[ind].Respuestas[3].Valor = valor;
                indicadores[ind].Respuestas[3].TipoValor = '%';
                cambiaCumplimiento(ind, 3, valor);
                if (indicadores[ind].CapturaCalificacion) {
                    calificacionIndicador(ind);
                }
                break;
            case 10:
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                let indBase = indicadores.findIndex(o => o.key == indicadores[indicadorAfecta].IdBase);
                let valBase = indicadores[indBase].Respuestas[2].Valor;
                valor = (valorBase * val * valBase).toFixed(2);
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 11:
                indicadorBase = indicadores.findIndex(o => o.key == indicadores[indicadorAfecta].IdBase)
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                valor = ((valorBase / val) * 100).toFixed(2);
                valor = isFinite(valor) ? valor : 0;
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                break;
            case 12:
                let iBase = indicadores.findIndex(o => o.key == indicadores[indicadorBase].IdBase);
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                let vBase = indicadores[iBase].Respuestas[2].Valor;
                valor = (valorBase * val * vBase).toFixed(2);
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 13:
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                valor = (valorBase / val).toFixed(2) * 100;
                valor = isFinite(valor) ? valor : 0;
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 14:
                valorBase = indicadores[ind].Respuestas[1].Valor;
                valor = Math.round(val) > Math.round(valorBase) ? 0 : 100;
                console.log('Cumplimiento', valor, val, valorBase);
                indicadores[ind].Respuestas[3].Valor = valor;
                indicadores[ind].Respuestas[3].TipoValor = '%';
                if (indicadores[ind].CapturaCalificacion) {
                    calificacionIndicador(ind);
                }
                let idReplica = indicadores[ind].key;
                let rep = indicadores.filter(ob => ob.IdReplica == idReplica && ob.puesto == indicadores[ind].puesto)
                if (rep.length > 0) {
                    rep.forEach((r) => {
                        let index = indicadores.findIndex(o => o.key == r.key);
                        cambiaValorObjetivo(index, 1, val, indicadores[index].Respuestas[1].TipoCambio);

                    })
                }
                break;
            case 15:
                cambiaValorReal(indicadorAfecta, 2, val, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 16:
                indicadores[ind].Respuestas[2].TipoValor = '%';
                calculaPromedioReal(ind);
                break;
            case 17:
                //Tipo de cambio exclusivo para indicador Costo de nomina       
                let indicadoresNomina = indicadores.filter(o => o.IdPadre == idPadre && o.Indicador != 'Valor mensual costo de nómina' && o.Indicador != 'Utilidad Bruta' && o.Indicador != 'Saldo vencido');
                let nomina = 0;
                indicadoresNomina.forEach((nom) => {
                    nomina += Math.round(nom.Respuestas[2].Valor * 100) / 100;
                })
                indicadores[indicadorAfecta].Respuestas[2].TipoValor = '$';
                indicadores[ind].Respuestas[2].TipoValor = '$';
                cambiaValorReal(indicadorAfecta, 2, (nomina * 1).toFixed(2), indicadores[indicadorAfecta].Respuestas[2].TipoCambio);

                break;
            case 18:
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                valor = ((valorBase / val) * 100).toFixed(2);
                cambiaValorReal(indicadorPadre, 2, valor, indicadores[indicadorPadre].Respuestas[2].TipoCambio);
                break;
            case 19:
                cambiaValorReal(indicadorAfecta, 2, indicadores[indicadorAfecta].Respuestas[2].Valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                break;
            case 20:
                indicadores[ind].Respuestas[2].TipoValor = '$';
                valor = Math.round(val) > 0 ? 0 : 100;
                cambiaCumplimiento(indicadorAfecta, 3, valor);
                if (indicadores[indicadorPadre].IdPadre != 0) {
                    calculaPromedioCumplimiento(indicadorAfecta);
                }

                break;
            case 21:
                let indApp = indicadores.filter(o => o.IdPadre == idPadre && o.key != 551 && o.key != 763);
                let acum = 0;
                indApp.map((i) => {

                    let cump = (Math.round(i.Respuestas[2].Valor) / Math.round(i.Respuestas[1].Valor)) * 100
                    acum += cump > 100 ? 100 : cump;
                })
                let prom = (acum / indApp.length).toFixed(2);
                indicadores[ind].Respuestas[2].TipoValor = '%';
                cambiaCumplimiento(indicadorPadre, 3, prom);
                if (idAfecta != 0) {
                    let acumAux = 0;
                    let indAux = indicadores.filter(o => o.IdAfecta == idAfecta);
                    indAux.map((i) => {
                        let cumpAux = Math.round(i.Respuestas[2].Valor);
                        acumAux += cumpAux;
                    })
                    let prom2 = Math.round(acumAux / indAux.length);
                    indicadores[indicadorAfecta].Respuestas[2].Valor = prom2;
                    indicadores[indicadorAfecta].Respuestas[2].TipoValor = '%';
                    //cambiaValorReal(indicadorAfecta,2,prom2,0);
                }
                break;
            case 22:
                valorBase = indicadores[indicadorBase].Respuestas[1].Valor;
                let cum = (Math.round(val) / Math.round(valorBase)) * 100;
                valor = cum > 100 ? 100 : cum;
                indicadores[indicadorAfecta].Respuestas[2].TipoValor = '%';
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
                break;
            case 23:
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                valor = ((valorBase / val) * 100).toFixed(2);
                indicadores[indicadorAfecta].Respuestas[2].TipoValor = '%';
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio)
                break;
            case 24:
                valorBase = indicadores[indicadorBase].Respuestas[2].Valor;
                valor = ((val / valorBase) * 100).toFixed(2);
                indicadores[indicadorAfecta].Respuestas[2].TipoValor = '%';
                cambiaValorReal(indicadorAfecta, 2, valor, indicadores[indicadorAfecta].Respuestas[2].TipoCambio);
            default:
                break;
        }
        dispatch(changeIndicadorValue(col, val, indicadores))
        /**Toma todos los indicadores a los que se replica el valor y lo cambia */
        let idInd = indicadores[ind].key;
        replicas = indicadores.filter(ob => ob.IdReplica == idInd && ob.key != 27 && ob.key != 266)
        if (replicas.length > 0) {
            replicas.forEach((r) => {
                let index = indicadores.findIndex(o => o.key == r.key);
                cambiaValorReal(index, 2, val, indicadores[index].Respuestas[2].TipoCambio);
            })
        }
    }

    function calculaPromedioReal(ind) {
        console.log('Promedio real')
        let idPadre = indicadores[ind].IdPadre;
        let indPadre = indicadores.findIndex(o => o.key == idPadre);
        let pond = indicadores[indPadre].Respuestas[4].Valor;
        let calif = indicadores.filter(o => o.IdPadre == idPadre);
        let acumCumplimiento = 0;
        calif.forEach((c) => {
            acumCumplimiento += Math.round(c.Respuestas[2].Valor * 100) / 100
        })
        let promedio = (acumCumplimiento / calif.length).toFixed(2)
        cambiaValorReal(indPadre, 2, promedio, indicadores[indPadre].Respuestas[2].TipoCambio);
    }

    function cambiaCumplimiento(ind, col, cum) {
        console.log('Captura cumplimiento', indicadores[ind].Indicador)
        let val = cum > 100 ? 100 : cum;
        indicadores[ind].Respuestas[col].Valor = val;
        indicadores[ind].Respuestas[col].TipoValor = '%';
        indicadores[ind].Modificado = true;
        dispatch(changeFilter('CambiosGuardados', false));
        if (indicadores[ind].CapturaCalificacion) {
            calificacionIndicador(ind);
            calculaCalificacion(ind);
        }
        let IdInd = indicadores[ind].key;
        let replicas = indicadores.filter(ob => ob.IdReplica == IdInd)
        if (replicas.length > 0) {
            replicas.forEach((r) => {
                let index = indicadores.findIndex(o => o.key == r.key);
                cambiaCumplimiento(index, 3, val);
            })
        }
        /**Si tiene un tipo de valor diferente a 0 (TipoCambio == 1) calcula el promedio para el indicador padre */
        if (indicadores[ind].Respuestas[col].TipoCambio == 1) {
            console.log('Calcula el promedio', indicadores[ind].Indicador, indicadores[ind].Respuestas[col].TipoCambio);
            calculaPromedioCumplimiento(ind);
        }
        dispatch(changeIndicadorValue(col, val, indicadores));
    }

    function calculaPromedioCumplimiento(ind) {
        console.log('Calcula cumplimiento', indicadores[ind].Indicador)
        let idPadre = indicadores[ind].IdPadre;
        let indPadre = indicadores.findIndex(o => o.key == idPadre);
        let pond = indicadores[indPadre].Respuestas[4].Valor;
        let calif = indicadores.filter(o => o.IdPadre == idPadre);
        let acumCumplimiento = 0;
        calif.forEach((c) => {
            acumCumplimiento += Math.round(c.Respuestas[3].Valor * 100) / 100
        })
        let promedio = (acumCumplimiento / calif.length).toFixed(2)
        let calificacion = (promedio * (pond / 100)).toFixed(2);
        indicadores[indPadre].Respuestas[3].Valor = promedio;
        indicadores[indPadre].Respuestas[3].TipoValor = '%';
        if (indicadores[indPadre].CapturaCalificacion) {
            indicadores[indPadre].Respuestas[5].Valor = calificacion;
            indicadores[indPadre].Respuestas[5].TipoValor = '%';
            indicadores[indPadre].Modificado = true;
            calculaCalificacion(indPadre);
        }
    }

    function calificacionIndicador(ind) {
        let cump = indicadores[ind].Respuestas[3].Valor
        let pond = indicadores[ind].Respuestas[4].Valor
        let calif = (cump * (pond / 100)).toFixed(2);
        console.log('Calificacion', calif);
        indicadores[ind].Respuestas[5].Valor = calif;
        indicadores[ind].Respuestas[5].TipoValor = '%';
    }

    function calculaCalificacion(ind) {
        console.log('Calcula calificacion', indicadores[ind].Indicador)
        let id = indicadores[ind].IdPadre
        let padre = indicadores.findIndex(o => o.key == id);
        let calif = indicadores.filter(ob => ob.IdPadre == id && ob.CapturaCalificacion)
        let calificacion = 0;
        calif.forEach((c) => {
            calificacion += Math.round(c.Respuestas[5].Valor * 100) / 100
        })
        indicadores[padre].Respuestas[5].Valor = Math.round(calificacion * 100) / 100;
        indicadores[padre].Respuestas[5].TipoValor = '%';
        indicadores[padre].Modificado = true;
        if (indicadores[padre].IdPadre !== 0) {
            calculaCalificacion(padre)
        } else {
            calculaCalifiacionGral(indicadores[ind].puesto);
        }
    }

    function calculaCalifiacionGral(puesto) {
        let titulos = indicadores.filter(ob => ob.puesto == puesto && ob.Nivel == 0)
        let calificacion = 0;
        titulos.forEach((t) => {
            calificacion += Math.round(t.Respuestas[5].Valor * 100) / 100;
        })
        calificaciones[puesto] = (calificacion).toFixed(2);
    }

    function formatoNumeros(x, tipo) {
        switch (tipo) {
            case '$':
                return tipo + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            case '%':
                return x.toString() + tipo;
            case 'F':
                return moment(x).format('LLLL').toString().replace('0:00', '')
            default:
                return x;
        }
    }


    const tabla = indicadores.map((ind, i) => {
        let color = (ind.CapturaCalificacion && ind.Respuestas[5].Valor == '' && ind.TipoIndicador == 'Indicador') ||
            (ind.Respuestas[1].Manual && ind.Respuestas[1].Valor == '') ||
            (ind.Respuestas[2].Manual && ind.Respuestas[2].Valor == '') ||
            (ind.Pendiente && !ind.Modificado)
            ? 'red' : estilos[ind.TipoIndicador].color;
        return (
            ind.puesto == puesto ?
                <Row key={ind.key}
                    className={'m-eval-row'} >
                    <Cell
                        style={{
                            paddingLeft: ind.Nivel + 'rem',
                            backgroundColor: estilos[ind.TipoIndicador].backgroundColor,
                            color: color,
                            textTransform: estilos[ind.TipoIndicador].textTransform,
                            textAlign: estilos[ind.TipoIndicador].textAlign,
                            paddingTop: estilos[ind.TipoIndicador].paddingTop,
                            paddingBottom: estilos[ind.TipoIndicador].paddingBottom,
                            borderTop: estilos[ind.TipoIndicador].borderTop,
                            borderBottom: estilos[ind.TipoIndicador].borderBottom,
                            borderLeft: estilos[ind.TipoIndicador].borderLeft,
                            borderRight: estilos[ind.TipoIndicador].borderRight,
                            fontWeight: ind.CapturaCalificacion ? 'bold' : estilos[ind.TipoIndicador].fontWeight,
                            display: 'table-cell',

                        }}
                    >
                        <div style={
                            { backgroundColor: 'transparent' }} > {ind.Indicador} </div>
                    </Cell>
                    {
                        columnas.map((c, index) => {
                            const tipo = indicadores[i].Respuestas[c.IdColumna].TipoValor;
                            const pre = tipo == '$' ? tipo : '';
                            const sub = tipo == '%' ? tipo : '';
                            if (indicadores[i].Respuestas[c.IdColumna].Manual) {
                                return (<Cell key={c.IdColumna}
                                    style={estilos['Celda' + ind.TipoIndicador]} >
                                    <NumberFormat
                                        thousandSeparator={true}
                                        prefix={pre}
                                        suffix={sub}
                                        key={`${Math.floor((Math.random() * 1000))}-min`}
                                        defaultValue={indicadores[i].Respuestas[c.IdColumna].Valor}
                                        style={{ textAlign: 'center', width: c.Longitud, fontWeight: ind.CapturaCalificacion ? 'bold' : 'none' }}
                                        onKeyDown={(event) => onChange(c.IdColumna, i, event, indicadores[i].Respuestas[c.IdColumna].TipoCambio)}
                                        readOnly={!fechaValida}
                                    />
                                </Cell>
                                )
                            } else {

                                return (<Cell style={estilos['Celda' + ind.TipoIndicador]}
                                    key={c.IdColumna} >
                                    <div key={`${Math.floor((Math.random() * 1000))}-min`}
                                        style={{ textAlign: c.IdColumna == 6 ? 'left' : 'center', width: c.Longitud, fontWeight: ind.CapturaCalificacion ? 'bold' : 'none', overflowWrap: 'break-word' }} >
                                        {!ind.CapturaCalificacion && c.Columna == 'Calificación' ? '' : formatoNumeros(indicadores[i].Respuestas[c.IdColumna].Valor, tipo)}
                                    </div>
                                </Cell>
                                )
                            }
                        })
                    }
                </Row> : ''
        )
    });
    return (
        <div>
            <div style={
                { width: '100%', height: '75vh', maxWidth: '100%', float: 'left', maxHeight: '75vh', border: '1px solid black' }} >
                <StickyTable borderWidth={3}
                    borderColor={'black'}
                    stickyHeaderCount={1}
                    stickyColumnCount={1} >
                    <Row >
                        <Cell style={estilos['Encabezado']}
                            key={0} > Indicador </Cell>
                        {
                            columnas.map((col, index) => {
                                return (<Cell style={estilos['Encabezado']}
                                    key={col.IdColumna} > {col.Columna} </Cell>
                                )
                            })
                        } </Row>
                    {tabla}
                </StickyTable>
            </div>
        </div>
    )
}
export default TabContent;